<template>
  <div
    class="subscription-page"
    data-test="page-subscription"
  >
    <loader v-show="!data_loaded" />
    <div v-if="data_loaded">
      <div v-if="subscriptionPlatform === 'web'">
        <h5 class="header">
          Your Subscription
        </h5>
        <div class="current-plan">
          <div class="details">
            <el-row
            >
              <el-col :span="8">
                <div class="section t-l">
                  <div>Plan</div>
                  <div v-if="currentSubscriptionStatus">
                    <h5 v-if="currentSubscriptionStatus === 'FREE TRIAL'">Free Trial</h5>
                    <h5 v-if="currentSubscriptionStatus === 'PREMIUM'">Premium</h5>
                    <h5 v-if="currentSubscriptionStatus === 'FREE'">Free</h5>
                  </div>
                  <h5 v-else>
                    Free
                  </h5>
                  <div class="small-text">
                    {{ expiry }}
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="section t-c">
                  <div>Price</div>
                  <h5 data-test="currentprice">{{ subscription.final_price || '0.0' | amountFilter(subscription.currency || userDefaultPricing.currency) }}</h5>
                  <!-- <div class="small-text">{{ subscription.final_price || '0.0' | taxFilter(subscription.currency) }}</div> -->
                </div>
              </el-col>
              <el-col
                :span="8"
                class="t-r">
                <a
                  class="cursor-pointer"
                  data-test="btn-manage"
                  @click="openManageModel"
                >
                  Manage
                </a>
              </el-col>
            </el-row>
            <el-alert
              v-if="showSuccessMessage"
              :title="successMessage"
              class="success-message"
              type="success"
              show-icon />
            <el-row
              v-if="isCardExpired"
              class="custom-error-alert"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <el-row
                type="flex"
                align="middle">
                <i class="el-icon-warning" />
                <span>Your credit card has an invalid expiration date</span>
              </el-row>
              <div
                class="action"
                @click="openUpgradeModel(event, true)">Update Now</div>
            </el-row>
          </div>
        </div>
        <h5
          v-if="isSubscribed && !isCanceled"
          class="header"
        >
          Your Next Charge
        </h5>
        <div
          v-if="isSubscribed && !isCanceled"
          class="next-charge"
        >
          <div class="details">
            <el-row
            >
              <el-col :span="8">
                <div class="section t-l">
                  <div>Date</div>
                  <h5>{{ subscription.renewal_date || subscription.expire_at || subscription.trial_end_date | dateFormat }}</h5>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="section t-c">
                  <div>Price</div>
                  <h5 data-test="nextprice">
                    {{ subscription.next_payment_due || '0.0' | amountFilter(subscription.currency) }}
                  </h5>
                  <div class="small-text">
                    {{ subscription.next_payment_due || '0.0' | taxFilter(subscription.currency) }}
                  </div>
                </div>
              </el-col>
              <el-col
                :span="8"
                class="t-r">
                <a
                  class="cursor-pointer"
                  data-test="btn-view"
                  @click="openInvoiceModel"
                >
                  View
                </a>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div v-if="subscriptionPlatform !== 'web'">
        <h5 class="header">
          Your Subscription
        </h5>
        <div class="current-plan">
          <div class="details">
            <el-row
              type="flex"
              align="top"
              justify="space-between"
            >
              <div>
                <div class="section">
                  <div>Plan</div>
                  <div v-if="currentSubscriptionStatus">
                    <h5 v-if="currentSubscriptionStatus === 'FREE TRIAL'">Free Trial</h5>
                    <h5 v-if="currentSubscriptionStatus === 'PREMIUM'">Premium</h5>
                    <h5 v-if="currentSubscriptionStatus === 'FREE'">Free</h5>
                  </div>
                  <h5 v-else>
                    Free
                  </h5>
                  <div class="small-text">
                    {{ expiry }}
                  </div>
                </div>
              </div>
              <div>
                <div class="section">
                  <div>Price</div>
                  <h5>{{ subscription.final_price || '0.0' | amountFilter(subscription.currency || userDefaultPricing.currency) }}</h5>
                  <div class="small-text">
                    {{ subscription.final_price || '0.0' | taxFilter(subscription.currency) }}
                  </div>
                </div>
              </div>
              <div
                class="t-r section"
              >
                <div>Subscribed On</div>
                <h5>{{ subscriptionPlatform }}</h5>
              </div>
            </el-row>
          </div>
        </div>
      </div>
      <div
        v-if="subscriptionPlatform === 'ios'"
        class="instructions"
      >
        <div>
          <div>To manage your subscription:</div>
          <div>
            <div>1. Go to the iOS App Store</div>
            <div>2. Go to Account Settings > Manage Subscriptions</div>
            <div>3. Look for your Luminary subscription</div>
          </div>
        </div>
      </div>
      <div
        v-if="subscriptionPlatform === 'android'"
        class="instructions"
      >
        <div>
          To manage your subscription:
          <div>
            <div>1. On your Android phone or tablet, open the Google Play Store Google Play.</div>
            <div>2. Check if you’re signed in to the correct Google Account.</div>
            <div>3. Tap Menu and then Subscriptions.</div>
            <div>4. Select the subscription you want to cancel.</div>
            <div>5. Tap Cancel subscription.</div>
            <div>6. Follow the instructions.</div>
          </div>
        </div>
      </div>

      <div v-if="subscriptionPlatform === 'web'">
        <transaction-history
          :count="totalTransactions"
        />
      </div>
      <div
        v-if="data_loaded && !isSubscribed && !subscription.uuid"
        class="non-subscribed-CTA t-c m-a"
      >
        <el-button
          type="primary"
          class="m-t"
          data-test="btn-starttrial"
          @click="openUpgradeModel">
          Start a
          <span
            v-if="promoMeta.trialPeriod > 1"
            class="line-through">1 month</span> {{ promoMeta.formattedTrialPeriod }} free trial
        </el-button>
        <div>{{ userDefaultPricing.price | amountFilter(userDefaultPricing.currency) }} + tax after trial ends</div>
        <div>Cancel anytime,
          <router-link
            to="/termsfreetrial"
            target="_blank"
          >
            terms apply
          </router-link>.
        </div>
      </div>
    </div>
    <adyen-modal
      :show_modal="showAdyenUpgradeModel"
      :update_payment="updatePaymentInfo"
      @close="closeUpgradeModel"
    />
    <adyen-unsubscribe-modal
      :show_modal="showAdyenDowngradeModel"
      @close="closeDowngradeModel"
    />
    <manage-subcription-modal
      :show_modal="showManageSubscriptionModal"
      :transaction="transaction"
      @openUpgradeModal="openUpgradeModel"
      @close="closeManageModel"
    />
    <price-breakdown-modal
      :show_modal="showPriceBreakDownModal"
      :invoice-details="NextChargeInvoiceDetails"
      :next-charge="true"
      @close="closeInvoiceModel"/>
  </div>
</template>

<script>
import Subscription from '../../services/Subscription';
import Loader from '../../components/Loader';
import AdyenSubscriptionModal from '../../components/subscription/UpgradeModal';
import AdyenUnsubscribeModal from '../../components/subscription/DowngradeModal';
import ManageSubscriptionModal from '../../components/subscription/ManageSubscriptionModal';
import PriceBreakdownModal from '../../components/subscription/PricebreakdownModal';
import TransactionHistory from '../../components/subscription/TransactionHistory';
import PageMixin from '../../shared/pageMixin';

export default {
  name: 'Subscriptions',
  components: {
    Loader,
    'adyen-modal': AdyenSubscriptionModal,
    'adyen-unsubscribe-modal': AdyenUnsubscribeModal,
    'transaction-history': TransactionHistory,
    'manage-subcription-modal': ManageSubscriptionModal,
    'price-breakdown-modal': PriceBreakdownModal,
  },
  mixins: [PageMixin],
  data() {
    return {
      pageName: 'Subscriptions',
      data_loaded: false,
      subscriptionProvider: null,
      plan_id: process.env.STRIPE_PLAN_ID,
      subscription: {},
      user: this.$store.getters.user || {},
      showAdyenUpgradeModel: false,
      showAdyenDowngradeModel: false,
      showManageSubscriptionModal: false,
      updatePaymentInfo: false,
      totalTransactions: 0,
      showSuccessMessage: false,
      successMessage: '',
      showPriceBreakDownModal: false,
      NextChargeInvoiceDetails: {},
      transaction: {},
    };
  },
  computed: {
    isSubscribed() {
      return this.$store.getters.user && this.$store.getters.user.is_subscribed;
    },
    subscriptionPlatform() {
      let platform = 'web';
      if (this.subscription && this.subscription.uuid) {
        platform = this.subscription.subscription_type;
      }
      return platform;
    },
    currentSubscriptionStatus() {
      const { userSubscription } = this.$store.getters;

      if (userSubscription) {
        return userSubscription.subscription_status;
      }

      return '';
    },
    subscriptionStatus() {
      let status = 'Free';
      if (this.subscription && this.subscription.trial_end_date) {
        const currentDate = new Date();
        const trialEndDate = new Date(this.subscription.trial_end_date);
        if (currentDate.getTime() >= trialEndDate.getTime()) {
          status = 'Premium';
        }
      }
      return status;
    },
    isCanceled() {
      return this.subscription && this.subscription.is_cancelled;
    },
    // remainingDays() {
    //   const currentDate = new Date();
    //   const nDate = this.subscription.trial_end_date || this.subscription.expire_at;
    //   const nextdate = nDate ? new Date(nDate) : new Date();
    //   const diff = nextdate.getTime() - currentDate.getTime();
    //   let totalDays = (((diff / 1000) / 60) / 60) / 24;
    //   if (totalDays) {
    //     totalDays = Math.floor(totalDays);
    //   }
    //   return `${totalDays} ${totalDays === 1 ? 'day' : 'days'}`;
    // },
    userSubscription() {
      return this.$store.getters.userSubscription;
    },
    userDefaultPricing() {
      return this.$store.getters.pricing;
    },
    isTrialEnded() {
      let isTrialEnded = false;
      const trialEndDate = this.subscription.trial_end_date ? new Date(this.subscription.trial_end_date) : null;
      const currentDate = new Date();
      if (!trialEndDate) {
        isTrialEnded = true;
      } else if (trialEndDate && trialEndDate < currentDate) {
        isTrialEnded = true;
      }
      return isTrialEnded;
    },
    isCardExpired() {
      let flag = false;
      const currentDate = new Date();
      if (this.transaction && this.transaction.card_expiry) {
        const cardExpiry = this.transaction.card_expiry.split('/'); // api send date in format like: 1/2023
        const expiryMonth = parseInt(cardExpiry[0], 10);
        const expiryYear = parseInt(cardExpiry[1], 10);
        if (expiryYear < currentDate.getFullYear()) {
          flag = true;
        } else if ((expiryYear === currentDate.getFullYear()) && (expiryMonth < (currentDate.getMonth() + 1))) {
          flag = true;
        }
      }
      return flag;
    },
    expiry() {
      const expiryDateString = this.userSubscription ? this.userSubscription.expire_at : '';
      if (!expiryDateString) {
        return '';
      }
      const expiryDate = new Date(expiryDateString);
      const currentDate = new Date();
      let expiryText = '';
      if (currentDate > expiryDate) {
        expiryText = 'Expired';
      } else {
        expiryText = 'Expires';
      }
      return `${expiryText} ${this.$options.filters.dateFormat(expiryDateString)}`;
    },
  },
  mounted() {
    window.eventBus.$emit('settings-tab-change', 'subscription');
    this.data_loaded = false;
    this.user = this.$store.getters.user || {};
    this.subscriptionProvider = new Subscription();
    this.fetchSubscription();
    this.getLatestTransaction();
  },
  methods: {
    fetchSubscription() {
      this.subscription = this.$store.getters.userSubscription || {};
      if (this.subscription && this.subscription.uuid) {
        // this.subscription.trial_end_date = null;
        this.data_loaded = true;
        return;
      }

      this.subscriptionProvider
        .getSubscription()
        .then((resp) => {
          this.data_loaded = true;
          this.subscription = resp || {};
          this.$store.commit('setUserSubscription', this.subscription);
          // this.subscription.trial_end_date = null;
        })
        .catch(() => {
          this.data_loaded = true;
          this.subscription = {};
          // this.showErrorMsg(error && error.body && error.body.message ? error.body.message : error);
        });
    },
    subscribe() {
      this.$router.push('/premium-buy');
    },
    cancelSubscription() {
      this.confirmDelete('Are you sure you want to unsubscribe?')
        .then((proceed) => {
          if (proceed) {
            this.subscriptionProvider
              .cancelSubscription()
              .then(() => {
                this.user.is_subscribed = false;
                this.$store.dispatch('setSubscriptionId', '');
              })
              .catch((error) => {
                this.showErrorMsg(error);
              });
          }
        })
        .catch(() => {

        });
    },
    // New methods
    openUpgradeModel(event, update) {
      this.updatePaymentInfo = false;
      if (update) {
        this.updatePaymentInfo = true;
      }
      this.showAdyenUpgradeModel = true;
    },
    closeUpgradeModel(success) {
      if (success) {
        const { user } = this.$store.getters;
        if (user.registration_state !== 'complete') {
          this.$router.push('/user-categories');
          return;
        }
      }
      this.showAdyenUpgradeModel = false;
      this.fetchSubscription();
      this.getLatestTransaction();
      this.totalTransactions++;
    },
    openDowngradeModel() {
      this.showAdyenDowngradeModel = true;
    },
    closeDowngradeModel() {
      this.showAdyenDowngradeModel = false;
      this.fetchSubscription();
      this.totalTransactions++;
    },
    openManageModel() {
      this.showManageSubscriptionModal = true;
    },
    closeManageModel(success, action) {
      this.showManageSubscriptionModal = false;
      this.showAdyenUpgradeModel = false;
      this.totalTransactions++;
      if (success) {
        this.fetchSubscription();
        this.showSuccessMessage = true;
        this.successMessage = 'Your plan has been successfully updated';
        const { user } = this.$store.getters;
        if (user.registration_state !== 'complete' && action === 'upgrade') {
          this.$router.push('/user-categories');
        }
      }
    },
    openInvoiceModel() {
      const referralDiscount = (this.subscription.total_price || 7.99) - this.subscription.next_payment_due;
      this.$set(this.NextChargeInvoiceDetails, 'chargeAmount', (this.subscription.total_price || 7.99));
      this.$set(this.NextChargeInvoiceDetails, 'currency', this.subscription.currency);
      this.$set(this.NextChargeInvoiceDetails, 'taxAmount', 0);
      this.$set(this.NextChargeInvoiceDetails, 'discount', 0);
      this.$set(this.NextChargeInvoiceDetails, 'referralDiscount', referralDiscount);
      this.showPriceBreakDownModal = true;
    },
    closeInvoiceModel() {
      this.showPriceBreakDownModal = false;
    },
    getLatestTransaction() {
      const params = {
        txn_type: 'card_added',
        limit: 1,
      };
      this.subscriptionProvider.fetchTransactionHistory(params).then((resp) => {
        this.loading = false;
        if (resp && resp.length) {
          [this.transaction] = resp;
        }
      })
        .catch(() => {
        });
    },
  },
};
</script>

<style lang="scss">
.subscription-page{
  .success-message {
    margin-top: 10px;
  }

  .view-details {
    margin: auto 0;
  }

  max-width: 655px;
  margin: auto;
  padding: 59px 0;
  .header{
    font-size: 24px;
    font-family: "ITC Clearface";
    line-height: 28px;
    padding-left: 24px;
  }
  h5{
    font-size: 24px;
    font-family: "ITC Clearface";
    line-height: 28px;
  }
  .el-button{
    text-transform: none;
  }
  .small-text {
    font-size: 11px;
    line-height: 13px;
    color: #666666;
    margin-top: 0px !important;
  }
  .current-plan, .next-charge {
    margin-bottom: 35px;
    .details {
      background-color: #F8F8F8;
      padding: 24px;
      margin-bottom: 8px;
      .el-col:nth-child(3) {
        margin-top: 25px;
      }
      .section > div {
        &:not(.small-text) {
          margin-bottom: 10px;
        }
      }

      .section > div:first-child {
        font-size: 14px;
        color: #666666;
      }

      h5 {
        margin-bottom: 0px;
      }

      .custom-error-alert {
        padding: 8px 16px !important;
        background-color: #fef0f0;
        border: 1px solid #f56c6c !important;
        box-sizing: border-box;
        border-radius: 4px;
        font-size: 14px !important;
        line-height: 18px;
        .el-icon-warning{
          color: #f56c6c;
          font-size: 24px;
          margin-right: 6px;
        }
        .action {
          color: #f56c6c;
          cursor: pointer;
        }
      }
    }

    h5{
      margin-top: 0px;
    }
  }

  .non-subscribed-CTA{
    div{
      font-size: 14px;
      line-height: 18px;
      margin: 8px 0;
      color: #666666;
    }
  }

  .el-dialog{
    border: 1px solid #BABABA;
    max-width: 712px;
    width: 100%;
    border-radius: 8px;

    .el-dialog__header{
      padding: 0px;
      .el-dialog__headerbtn .el-dialog__close{
        font-size: 24px;
        color: #666666;
      }
    }
    .el-dialog__body{
      padding: 57px 123px;
      .heading {
        font-size: 20px;
        line-height: 24px;
        margin-bottom: 34px;
        margin-top: 0;
        color: #111111;
      }
      .info-section{
        h4{
          margin-bottom: 32px;
        }
        p{
          margin-bottom: 30px;
        }
        .el-button{
          margin-top: 12px;
        }
      }
      p {
        font-size: 16px;
        color: #111111;
        line-height: 20px;
      }
      .action-button, .purchase-btn {
        font-size: 16px;
        line-height: 20px;
        font-weight: normal;
        margin-top: 42px;
      }
    }
  }

  .instructions  div {
    margin-bottom: 12px;
  }
}

@media (max-width: 567px) {
  .subscription-page{
    max-width: 100%;
    .el-dialog{
      .el-dialog__body{
        padding: 30px 20px;
      }
    }
    .header{
      font-size: 24px;
      line-height: 24px;
      padding-left: 24px;
    }
    h5{
      font-size: 20px;
      line-height: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/account/Subscriptions.vue